export type ImageRenderMeta = {
  width: number;
  height: number;
};

const fixedMeta = (width: number, height: number): ImageRenderMeta => ({ width, height });

const IMAGE_META: Record<string, ImageRenderMeta> = {
  "/onboarding_lander_science.webp": fixedMeta(900, 502),
  "/romain_skyline.webp": fixedMeta(900, 491),
  "/romain_skyline.avif": fixedMeta(900, 491),
  "/roman_republic.webp": fixedMeta(900, 491),
  "/pirate_engineering.webp": fixedMeta(900, 590),
  "/pirate_engineering.avif": fixedMeta(900, 590),
  "/science_lightspeed.webp": fixedMeta(900, 491),
  "/roman_gladiators.webp": fixedMeta(900, 491),
  "/pysch_representation.webp": fixedMeta(900, 502),
  "/pysch_representation.avif": fixedMeta(900, 502),
  "/science_ac.webp": fixedMeta(900, 491),
  "/history_julius_caesar.webp": fixedMeta(900, 491),
  "/high_court.webp": fixedMeta(900, 491),
  "/science_preindustrial_engineering.webp": fixedMeta(900, 491),
  "/science_chemicals.webp": fixedMeta(1100, 600),
  "/lumi_building_profile.webp": fixedMeta(900, 491),
  "/lumi_building_questmap.webp": fixedMeta(900, 521),
  "/persona_spark_chaser.webp": fixedMeta(1100, 575),
  "/persona_apprentice.webp": fixedMeta(1100, 575),
  "/persona_ranger.webp": fixedMeta(1100, 575),
  "/persona_navigator.webp": fixedMeta(1100, 614),
  "/persona_sage.webp": fixedMeta(1100, 575),
  "/persona_devoted_scholar.webp": fixedMeta(1100, 614),
  "/characters_1.webp": { width: 500, height: 809 },
  "/characters_2.webp": { width: 500, height: 750 },
  "/characters_3.webp": { width: 500, height: 757 },
  "/characters_4.webp": { width: 500, height: 732 }
};

export const getImageRenderMeta = (src?: string | null): ImageRenderMeta | undefined => {
  if (!src) {
    return undefined;
  }
  return IMAGE_META[src];
};

export const getImagePreloadCandidates = (src?: string | null): string[] => {
  if (!src) {
    return [];
  }

  return [src];
};

export const getImagePreloadCandidatesForSources = (
  sources?: Array<string | null | undefined>
): string[] => {
  if (!sources || sources.length === 0) {
    return [];
  }

  return Array.from(new Set(sources.flatMap((source) => getImagePreloadCandidates(source))));
};
